/**
 * Notification API — Phase 7.
 *
 * BE endpoints:
 *   GET  /api/v1/user/notifications
 *   GET  /api/v1/user/notifications/unread-count
 *   POST /api/v1/user/notifications/{id}/read
 *   POST /api/v1/user/notifications/read-all
 */
import { apiGet, apiPost } from "./client";

/**
 * BE PKNT_NOTI_HIST.NOTI_DIV_COMM_CD raw 값 (be NotificationKind / adbe NOTI_DIV 코드).
 * 탭/배지 정규화는 notificationMeta 가 담당한다.
 */
export type NotificationCode = string;

export interface NotificationItem {
  notificationSerialNo: number;
  category: NotificationCode;
  title: string;
  body: string;
  /** deep link URL (예: peeka://shipping/status/123) */
  deepLink?: string;
  readYn: "Y" | "N";
  createdAt: string;
}

export async function fetchNotifications(): Promise<NotificationItem[]> {
  const data = await apiGet<NotificationItem[] | null>("/notifications");
  return data ?? [];
}

export async function markNotificationRead(id: number): Promise<void> {
  await apiPost<void>(`/notifications/${id}/read`);
}

export async function markAllRead(): Promise<void> {
  await apiPost<void>("/notifications/read-all");
}

/**
 * 안 읽은 알림 존재 여부. 뱃지는 dot(유무만) 이라 개수를 세지 않는다.
 * BE 는 경량 존재검사로 `{ hasUnread }` 를 내려준다.
 */
export async function getUnreadFlag(): Promise<boolean> {
  const r = await apiGet<{ hasUnread?: boolean }>("/notifications/unread-count");
  return r?.hasUnread ?? false;
}
